import TheGrid from '@/views/campaigns/bestof/results/grid'

export default {
  path: '/campaigns/bestof/results',
  redirect: '/campaigns/bestof/results/index',
  name: 'bestof_results',
  meta: {
    auth: {
      redirect: {
        name: 'bestof_results.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Bestof'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: 'index',
    name: 'bestof_results.index',
    component: TheGrid,
    meta: {
      auth: true,
      label: 'Lista'
    }
  }]
}
